import {
    endpointDeleteApiKey,
    endpointDeleteManyApiKeys,
    endpointGetApiKeysList,
    resourceApiKey,
    resourceCustomUsers,
    resourceDocuments,
    resourceDocumentTypes,
    resourceIntegrations,
    resourceMenuDocumentTypes,
    resourceProfile,
    resourceRequests,
    resourceRules,
    resourceStatistics,
    resourceUserHistory,
    resourceUsers
} from '../constants';
import {DELETE, DELETE_MANY, FETCH, GET_LIST, GET_ONE} from './types';

/**
 * For posts update only, convert uploaded image in base 64 and attach it to
 * the `file` sent property, with `src` and `title` attributes.
 */
const addUploadFeature = (type, resource, params) => {
    const newParams = {...params};
    newParams.include = newParams.include || []; // To prevent errors with destructuring undefined
    if (!Array.isArray(newParams.include)) {
        newParams.include = [newParams.include];
    }

    let newResource = resource;

    if (newParams) {
        newParams.include = newParams.include || [];
    }

    if (resource === resourceRules) {
        newParams.include.push({relation: 'supplier'}, {relation: 'user'});
    }

    if (resource === resourceDocumentTypes && type === GET_ONE) {
        newParams.include.push(
            {relation: 'templateCollection'},
            {relation: 'ocrLanguage'},
            {relation: 'fileFormats'},
        );
        if (!newParams.include.find(el => el.relation === 'exportIntegrations')) {
            newParams.include.push({relation: 'exportIntegrations'});
        }
    }

    if (resource === resourceDocumentTypes && type === GET_LIST) {
        if (newParams.includes !== false) { // Do not apply includes for Autocomplete Fields
            newParams.include.push(
                {relation: 'templateCollection'},
                {relation: 'ocrLanguage'},
                {
                    relation: 'exportIntegrations', scope: {
                        fields: {
                            id: true,
                            name: true
                        }
                    }
                }
            );
        }
    }

    if (resource === resourceMenuDocumentTypes) { // do not apply previous includes
        newResource = resourceDocumentTypes;
    }

    if (resource === resourceDocuments && type === GET_LIST) {
        if (newParams.fields) {
            if (newParams.fields.pages) { // HACK for pages field
                delete (newParams.fields.pages);
                newParams.fields['pageIndex'] = true;
                newParams.fields['pagesTotal'] = true;
                newParams.fields['originalTotalPages'] = true;
            }
            newParams.fields['fields'] = true; // HACK for fields
            newParams.include.push({
                    relation: 'user', scope: {
                        fields: {
                            id: true,
                            fullName: true,
                            email: true,
                            role: true
                        }
                    }
                }, {
                    relation: 'request', scope: {
                        fields: {
                            webhookStatus: true,
                            webhookUrl: true
                        }
                    }
                }, {
                    relation: 'ocrLanguage'
                }
            );
        }

        if (newParams.filter) {
            // Filter for JSON exportInfo field (empty array <-> not empty array)
            if (newParams.filter.hasOwnProperty('exportInfo')) {
                const {exportInfo, ...rest} = newParams.filter;

                if (exportInfo.toLowerCase() === 'true') {
                    newParams.filter = {exportInfo: {nlike: '[]'}, ...rest};
                } else  if (exportInfo.toLowerCase() === 'false') {
                    newParams.filter = {exportInfo: {like: '[]'}, ...rest};
                }
            }
        }
    }

    if (resource === resourceCustomUsers && type === GET_LIST) {
        if (newParams.fields.hasOwnProperty('planData.recognizedPages')) {
            delete(newParams.fields['planData.recognizedPages']);
            delete(newParams.fields['configuration.invoiceDuration']);
            delete(newParams.fields['configuration.ocrProvider']);
            newParams.fields['planData'] = true;
        }

        if (newParams.filter) {
            const {email, fullName, ...rest} = newParams.filter;

            if (email) {
                newParams.filter = {id: email, ...rest};
            }

            if (fullName) {
                newParams.filter = {id: fullName, ...rest};
            }
        }
    }

    if (resource === resourceUsers || resource === resourceProfile) {
        newResource = resourceCustomUsers;
    }

    if (resource === resourceRequests) {
        newParams.include = [{relation: 'user'}, {relation: 'documents'}];
    }

    if (resource === resourceStatistics) {
        newResource = resourceRequests;
    }

    if (resource === resourceApiKey) {
        if (type === GET_LIST) {
            newResource = `${resourceCustomUsers}/${endpointGetApiKeysList}`;

            newParams.fields = {}; // HACK
            // TODO why not working?
            // newParams.include.push({relation: 'user', scope: {
            //         fields: {
            //             id: true,
            //             username: true,
            //             email: true,
            //             role: true
            //         }
            //     }});
        }
        if (type === DELETE) {
            newResource = `${resourceCustomUsers}/${endpointDeleteApiKey}`;
            type = FETCH;
        }
        if (type === DELETE_MANY) {
            newResource = `${resourceCustomUsers}/${endpointDeleteManyApiKeys}`;
            type = FETCH;
        }
    }

    if (resource === resourceIntegrations) {
        newParams.include.push(
            {relation: 'integrationCredentials'},
            {relation: 'rules'},
        );
    }

    if (resource === resourceUserHistory) {
        newParams.include.push(
            {relation: 'user'},
        );

        if (type === GET_ONE) {
            newParams.include.push(
                {relation: 'documentHistory'},
            );
        }
    }

    // for other request types and resources, fall back to the default request handler
    return {type, resource: newResource, params: newParams};
};

export default addUploadFeature;